import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import FeaturesSection from "./components/FeaturesSection";
import CategoriesSection from "./components/CategoriesSection";
import ArticlesSection from "./components/ArticlesSection";
import FAQSection from "./components/FAQSection";
import DownloadSection from "./components/DownloadSection";

const stats = [
  { value: "5000万+", label: "累计用户", icon: "ri-user-line" },
  { value: "200+", label: "覆盖赛事", icon: "ri-trophy-line" },
  { value: "99.9%", label: "直播稳定性", icon: "ri-signal-wifi-line" },
  { value: "4.8", label: "用户评分", icon: "ri-star-line" },
];

const homeSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      name: "大满贯APP",
      url: window.location.origin,
      description: "专业体育赛事直播与数据分析平台，提供安卓版APK官方下载",
      logo: `${window.location.origin}/logo.png`,
      contactPoint: {
        "@type": "ContactPoint",
        contactType: "customer service",
        email: "support@daman.com",
        availableLanguage: ["Chinese"],
      },
    },
    {
      "@type": "WebSite",
      name: "大满贯APP官方网站",
      url: window.location.origin,
      potentialAction: {
        "@type": "SearchAction",
        target: `${window.location.origin}/search?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@type": "SoftwareApplication",
      name: "大满贯APP",
      operatingSystem: "Android",
      applicationCategory: "SportsApplication",
      downloadUrl: `${window.location.origin}/#download`,
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "CNY",
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}
      />
      <Navbar />

      <main>
        <HeroSection />

        <FeaturesSection />

        <section className="w-full py-12 bg-background-50">
          <div className="max-w-5xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {stats.map((stat, index) => (
                <div key={index} className="text-center p-5 rounded-xl bg-background-100 border border-background-200/70">
                  <div className="w-10 h-10 mx-auto mb-3 rounded-lg bg-primary-100 flex items-center justify-center">
                    <i className={`${stat.icon} text-lg text-primary-600`}></i>
                  </div>
                  <div className="text-2xl md:text-3xl font-extrabold text-foreground-900 mb-1">
                    {stat.value}
                  </div>
                  <div className="text-sm text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <CategoriesSection />

        <ArticlesSection />

        <FAQSection />

        <DownloadSection />
      </main>

      <Footer />
    </>
  );
}